<template>
  <b-card v-loading="loading">
    <h4>Basic Details</h4>
    <b-form class="mt-3">
      <b-form-group>
        <label class="d-block">
          Ad Title
          <span class="pull-right text-grey" :class="{ 'text-danger' : details.title.length < 10 }">{{details.title.length}} / 64</span>
        </label>
        <b-form-input v-model="details.title" type="text" placeholder="Title of your listing" maxlength="64" />
      </b-form-group>
      <b-form-group>
        <label class="d-block">
          Description
          <span class="pull-right text-grey" :class="{ 'text-danger' : details.description.length < 10 }">{{details.description.length}} / 64000</span>
        </label>
        <b-form-textarea v-model="details.description" placeholder="Description of your listing" :rows="4" :max-rows="10" maxlength="64000"></b-form-textarea>
      </b-form-group>
    </b-form>
  </b-card>
</template>

<script>
export default {
  name: 'Basic',

  props: {
    details: {
      type     : Object,
      required : true,
    },
    loading: {
      type    : Boolean,
      default : false,
    }
  },

  data(){
    return {
      // State
      error : '',
    }
  }
};
</script>
